import { ShapesIcon } from "lucide-react";

import { cn } from "@/lib/utils";

/*
 * A Twin entity's mark wherever it appears: the chip in an answer (filled in
 * the entity colour, as workspace kinds are), the directory, its page and
 * Knowledge's entity types.
 */
export const TWIN_ENTITY_TONE = "var(--color-badge-blue)";
export const TwinEntityIcon = ShapesIcon;

export function TwinEntityGlyph({ className }: { className?: string }) {
  return (
    <TwinEntityIcon
      aria-hidden
      className={cn("size-4 shrink-0 text-muted-foreground", className)}
    />
  );
}
